import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import CustomCheckbox from '@/common/CustomCheckboxGroup/CustomCheckbox/CustomCheckbox';
import './CustomFormCheckbox.scss';
import { CustomFormControl } from '@/common/CustomFormControl/CustomFormControl';

export interface CustomFormCheckboxProps {
  name: string;
  label: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  showFormValueOnly?: boolean;
}

const CustomFormCheckbox = ({
  name,
  label,
  isRequired = false,
  isDisabled = false,
  isReadOnly = false,
  showFormValueOnly = false,
}: CustomFormCheckboxProps) => {
  const { trigger } = useFormContext();

  return (
    <CustomFormControl
      componentName={'Custom Form Checkbox'}
      name={name}
      isDisabled={isDisabled}
      isReadOnly={isReadOnly}
      showFormValueOnly={showFormValueOnly}
    >
      <Controller
        name={name}
        defaultValue={false}
        render={({ field: { value, onChange } }) => (
          <CustomCheckbox
            label={label}
            value={label} // Pass the label as the value since the checkbox is boolean
            onChange={newValue => {
              onChange(Boolean(newValue));
              trigger(name);
            }}
            isChecked={Boolean(value)}
            isRequired={isRequired}
            isDisabled={isReadOnly}
            isReadOnly={isReadOnly}
            isSingleCheckbox={true}
          />
        )}
      />
    </CustomFormControl>
  );
};

export default CustomFormCheckbox;
